import { z } from 'zod'

// Currency option schema
const currencyOptionSchema = z.object({
	rate: z.number(),
	amount: z.number(),
	lock: z.boolean(),
	date: z.string(),
})

const currencyOptionsSchema = z.record(z.string(), currencyOptionSchema)

/**
 * Shipping rate form validation schema
 * Matches the server-side ShippingRateFormSchema
 */
export const createShippingRateSchema = z.object({
	shippingRateName: z.string().min(1, 'Shipping rate name is required'),
	description: z.string().optional(),
	icon: z.string().optional(),
	amount: currencyOptionsSchema,
	isFree: z.boolean().optional().default(false),
	isPickupPoint: z.boolean().optional().default(false),
	highlighted: z.boolean().optional().default(false),
	shippingRateMinAmount: currencyOptionsSchema.optional().nullable(),
	shippingRateMaxAmount: currencyOptionsSchema.optional().nullable(),
	shippingRateMinWeight: z.number().optional().nullable(),
	shippingRateMaxWeight: z.number().optional().nullable(),
	countryCodes: z.array(z.string()).optional().default([]),
	pickupPointCarriers: z.array(z.string()).optional().nullable(),
})

export type CreateShippingRateFormData = z.input<typeof createShippingRateSchema>

export const updateShippingRateSchema = createShippingRateSchema
export type UpdateShippingRateFormData = z.input<typeof updateShippingRateSchema>

